import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import PageBreadcrumb from '../../common/components/layout/PageBreadcrumb';
import VehicleSectionsNav from '../VehicleSectionsNav';
import AddVehicleNoteForm from './AddVehicleNoteForm';
import VehicleNotesTable from './VehicleNotesTable';
import { useQueryString } from '../../common/helpers/queryString';
import { fetchAuctionNotes } from '../VehicleActions';
import ComponentCard from '../../common/components/cards/ComponentCard';

function VehiclesNotesPage() {
  const query = useQueryString();
  const dispatch = useDispatch();
  const { id: auctionId } = useParams();
  const auctionNotes = useSelector((state) => state.dealers.get('auctionNotes'));
  const itemsNotes = auctionNotes?.items || null;
  const totalItemsNotes = auctionNotes?.totalItems;
  const [searchParams, setSearchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
  });
  const changeOffsetNotes = (value) => {
    setSearchParams((prevState) => ({ ...prevState, offset: value }));
  };

  useEffect(() => {
    if (auctionId) {
      dispatch(fetchAuctionNotes(searchParams, auctionId));
    }
  }, [dispatch, searchParams]);

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'link', text: 'Vehicles', url: '/vehicles' },
    { id: 3, type: 'span', text: 'Vehicle notes' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Vehicle Notes" />
      <VehicleSectionsNav section="notes" />
      <ComponentCard title="Vehicle Notes" className="mb-3">
        <AddVehicleNoteForm searchParams={searchParams} />
        <VehicleNotesTable
          data={{ items: itemsNotes, total: totalItemsNotes }}
          offset={searchParams.offset}
          changeOffset={changeOffsetNotes}
        />
      </ComponentCard>
    </Container>
  );
}

export default VehiclesNotesPage;
